import { Status } from "../../../../../utils/enums"

const formData: Record<string, string> = {
  available_to: 'end_date',
  available_from: 'start_date',
  store_name: 'store',
  keyCode: 'keycode',
  class: 'clase',
}

const formatFilter = {
  search: 'search',
  from: 'date_init',
  to: 'date_end',
  questionnaireId: 'questionnaire_ids',
  zoneId: 'zone_ids',
  childZone: 'clase_ids',
  userType: 'user_type_ids',
  userId: 'user_ids',
  keyCodeId: 'key_codes',
  userTypeId: 'user_type_ids',
  areas: 'areas_ids',
  status: 'status_ids',
  departments: 'departments_ids',
  createYear: 'year',
  month: 'month',
  page: 'page',
  size: 'size',
  divisions: 'division_ids',
  percentage: 'range_results',
  roles: 'role_ids',
  filterByCurrentWeek: 'current_week',
}


const menuList: Record<string, number[]> = {
  [Status.TO_BE_STARTED]: [1, 2, 5, 6, 7, 8],
  [Status.STARTED]: [2, 5, 7, 8],
  [Status.PAUSE]: [2, 5, 7, 8],
  [Status.EXPIRED]: [2, 5, 7, 8],
  [Status.INCOMPLETE]: [2, 5, 7, 8],
  [Status.FINISHED]: [4, 3, 5, 7, 8],
  [Status.CANCEL]: [5, 7, 8],
  [Status.CLOSE]: [5, 7, 8],
  [Status.WAITING]: [2, 5, 7, 8],
}
export { formData, formatFilter, menuList }